module.exports = __webpack_public_path__ + "static/media/daffodil.118431d7.svg";